import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoCall, IoMail } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import { TbWorldWww } from "react-icons/tb";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import "./ContactPage.css";

function CommanComponentContact() {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactSubject, setContactSubject] = useState("");
  const [contactMessage, setContactMessage] = useState("");
  const [contactMobile, setContactMobile] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [otherSubject, setOtherSubject] = useState("");

  const subjectOptions = [
    { label: "Web Development", value: "Web Development" },
    { label: "Database Service", value: "Database Service" },
    { label: "Cloud Service", value: "Cloud Service" },
    { label: "Additional Service", value: "Additional Service" },
    { label: "Other", value: "Other" },
  ];

  const handleSubjectChange = (e) => {
    const value = e.value;
    setSelectedOption(value);
    if (value !== "Other") {
      setContactSubject(value);
      setErrors({ ...errors, contactSubject: "" });
    } else {
      setContactSubject("");
    }
  };

  const handleOtherSubjectChange = (e) => {
    const value = e.target.value;
    setOtherSubject(value);
    setContactSubject(value);
    if (value.length > 100) {
      setErrors({
        ...errors,
        contactSubject: "Cannot exceed 100 characters",
      });
    } else {
      setErrors({ ...errors, contactSubject: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      toast.error("Please fix the errors in the form.");
      return;
    }

    try {
      const response = await fetch("/saveContactUsEnquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: contactName,
          emailID: contactEmail,
          subject: contactSubject,
          message: contactMessage,
          mobileNumber: contactMobile,
        }),
      });

      if (response.status === 200) {
        toast.success("Details Added successfully!");
        setContactName("");
        setContactEmail("");
        setContactSubject("");
        setContactMessage("");
        navigate("/thankyou");
        setTimeout(() => {
          navigate("/");
        }, 10000);
      } else {
        toast.error("Some error occurred.");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const validate = () => {
    const errors = {};

    if (!contactName.match(/^[A-Za-z\s]{3,25}$/)) {
      errors.contactName =
        "Name must be 3-25 characters long and contain only alphabets and spaces.";
    }
    if (
      !contactEmail.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
    ) {
      errors.contactEmail = "Please enter a valid email address.";
    }
    if (!contactSubject.match(/^[A-Za-z\s]{3,100}$/)) {
      errors.contactSubject =
        "Subject must be 3-100 characters long and contain only alphabets and spaces.";
    }
    if (contactMessage.length < 3 || contactMessage.length > 300) {
      errors.contactMessage = "Message must be 3-300 characters long.";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  return (
    <div className="contact-page">
      <div className="grid">
        {/* Left: Contact Form */}
        <div className="col-12 md:col-6">
          <div className="contact-card">
            <h2
              className="Text-Gradient"
              style={{ fontFamily: "rockwell", fontSize: "1.3rem" }}
            >
              GET IN TOUCH
            </h2>
            <form onSubmit={handleSubmit} className="formgrid grid">
              <div className="field col-12 md:col-6">
                <label>Your Name</label>
                <InputText
                  value={contactName}
                  onChange={(e) => setContactName(e.target.value)}
                  className={errors.contactName ? "p-invalid w-full" : "w-full"}
                />
                {errors.contactName && (
                  <small className="p-error">{errors.contactName}</small>
                )}
              </div>

              <div className="field col-12 md:col-6">
                <label>Mobile</label>
                <InputText
                  value={contactMobile}
                  onChange={(e) => setContactMobile(e.target.value)}
                  className={
                    errors.contactMobile ? "p-invalid w-full" : "w-full"
                  }
                />
                {errors.contactMobile && (
                  <small className="p-error">{errors.contactMobile}</small>
                )}
              </div>

              <div className="field col-12">
                <label>Email</label>
                <InputText
                  type="email"
                  value={contactEmail}
                  onChange={(e) => setContactEmail(e.target.value)}
                  className={
                    errors.contactEmail ? "p-invalid w-full" : "w-full"
                  }
                />
                {errors.contactEmail && (
                  <small className="p-error">{errors.contactEmail}</small>
                )}
              </div>

              <div className="field col-12">
                <label>Enquiry About</label>
                <Dropdown
                  value={selectedOption}
                  options={subjectOptions}
                  onChange={handleSubjectChange}
                  placeholder="Select an option"
                  className={`w-full ${
                    errors.contactSubject ? "p-invalid" : ""
                  }`}
                />
                {selectedOption === "Other" && (
                  <InputText
                    value={otherSubject}
                    onChange={handleOtherSubjectChange}
                    placeholder="Enter subject"
                    className="w-full mt-2"
                  />
                )}
                {errors.contactSubject && (
                  <small className="p-error">{errors.contactSubject}</small>
                )}
              </div>

              <div className="field col-12">
                <label>Your Message</label>
                <InputTextarea
                  value={contactMessage}
                  onChange={(e) => setContactMessage(e.target.value)}
                  rows={3}
                  className={`w-full ${
                    errors.contactMessage ? "p-invalid" : ""
                  }`}
                />
                {errors.contactMessage && (
                  <small className="p-error">{errors.contactMessage}</small>
                )}
              </div>

              <div className="col-12">
                <Button
                  type="submit"
                  label="Submit"
                  className="p-button-info w-6 md:w-4"
                />
              </div>
            </form>
          </div>
        </div>

        {/* Right: Contact Info + Business Hours */}
        <div className="col-12 md:col-6">
          <div className="contact-card">
            <h2
              className="Text-Gradient"
              style={{ fontFamily: "rockwell", fontSize: "1.3rem" }}
            >
              CONTACT INFORMATION
            </h2>

            <div className="mb-4 contactPhones">
              <IoCall />
              
              <Link
                to="tel:+91 9490384177"
                style={{
                  textDecoration: "none",
                }}
              >
                +91 9490384177
              </Link>
              ,
              <Link
                to="tel:+91 7569192527"
                style={{
                  textDecoration: "none",
                }}
              >
                +91 7569192527
              </Link>
              ,
              <Link
                to="tel:+91 9573706658"
                style={{
                  textDecoration: "none",
                }}
              >
                +91 9573706658
              </Link>
            </div>

            <p className="mb-4">
              <IoMail />
              <Link
                to="mailto:support@clotatechnology.com"
                style={{
                  textDecoration: "none",
                }}
              >
                support@clotatechnology.com
              </Link>
            </p>

            <p className="mb-4">
              <TbWorldWww />
              <Link
                to="https://www.clotatech.com/"
                style={{
                  // fontSize: "14px",

                  textDecoration: "none",
                }}
              >
                <div>
                  <span style={{ fontFamily: "rockwell" }}>
                    WWW.CLOTATECH.COM
                  </span>
                </div>
              </Link>
            </p>

            <p className="mb-4">
              <FaLocationDot />{" "}
              <Link
                to="https://www.google.com/maps/place/WeWork+Raheja+Mindspace+-+Coworking+%26+Office+Space+in+Madhpur,+Hyderabad/@17.4410208,78.3627964,15z/data=!3m1!5s0x3bcb915dccf46fc7:0x99a52272bcfe9c03!4m10!1m2!2m1!1sSurvey+no+64+Building+Number+9+K+Raheja+Mindspace+Madhapur+Shaikpet+Hyderabad+Telangana+India+500081!3m6!1s0x3bcb93547b7c9039:0x852fa9e76e4ca65!8m2!3d17.4445364!4d78.3804499!15sCmRTdXJ2ZXkgbm8gNjQgQnVpbGRpbmcgTnVtYmVyIDkgSyBSYWhlamEgTWluZHNwYWNlIE1hZGhhcHVyIFNoYWlrcGV0IEh5ZGVyYWJhZCBUZWxhbmdhbmEgSW5kaWEgNTAwMDgxWmYiZHN1cnZleSBubyA2NCBidWlsZGluZyBudW1iZXIgOSBrIHJhaGVqYSBtaW5kc3BhY2UgbWFkaGFwdXIgc2hhaWtwZXQgaHlkZXJhYmFkIHRlbGFuZ2FuYSBpbmRpYSA1MDAwODEoADIfEAEiG79_oVOkktojw1bl0mC4kGkTen55bfvmyafGAjJoEAIiZHN1cnZleSBubyA2NCBidWlsZGluZyBudW1iZXIgOSBrIHJhaGVqYSBtaW5kc3BhY2UgbWFkaGFwdXIgc2hhaWtwZXQgaHlkZXJhYmFkIHRlbGFuZ2FuYSBpbmRpYSA1MDAwODHgAQD6AQQIABAa!16s%2Fg%2F11krwxc9t8?entry=ttu"
                style={{
                  textDecoration: "none",
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                #189 Clota Technology LLP 13th Floor, Survey No 64, Building
                Number9 K Raheja Mindspace, Madhapur, Hyderabad Shaikpet,
                Telangana, India – 500081
              </Link>
            </p>
            <h5>
              <span>Sales Office</span>{" "}
            </h5>
            <p className="mb-4">
              <FaLocationDot />
              <span>
                C-43, 002, Gandharv Shanti Nagar CHS Ltd., Sector 5, Near Ganesh
                Mandir, Mira Road East, Mumbai, Maharashtra, India – 401107
              </span>
            </p>
            <p className="mb-4">
              <FaLocationDot />
              <span>2/350 Sect H, Jankipuram Lucknow, UP, India 226021</span>
            </p>
          </div>

          <div className="contact-card mt-3">
            <h2 className="Text-Gradient" style={{ fontSize: "1.3rem" }}>
              Working Hours
            </h2>
            <p>Mon - Fri: 9:30 am - 6:30 pm</p>
          </div>
        </div>
      </div>

      {/* Map */}
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.5653668806155!2d78.3627964!3d17.4410208!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93547b7c9039%3A0x852fa9e76e4ca65!2sWeWork%20Raheja%20Mindspace%20-%20Coworking%20%26%20Office%20Space%20in%20Madhapur%2C%20Hyderabad!5e0!3m2!1sen!2sin!4v1691500000000!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="WeWork Raheja Mindspace Map"
        ></iframe>
      </div>
    </div>
  );
}

export default CommanComponentContact;
